import React, { useState, useRef } from 'react';

import { Button } from 'components/Button/RoundButton';
import { useDetectOutsideClick } from 'hooks/useDetectOutsideClick';
import {
  DropdownContainer,
  DropdownMenuContainer,
  DropdownItem,
  Divider,
  LabelAndCheckboxContainer,
  InputCheckbox,
  Label,
} from './styles';

export const ChangeDepartmentDropdown = ({ ticket, departments, onDepartmentChange }) => {
  const dropdownRef = useRef(null);
  const [isOpenDropdown, setIsOpenDropdown] = useDetectOutsideClick(dropdownRef, false);

  return (
    <DropdownContainer>
      <Button small primaryBlue primaryGreenBorder margin="5px" onClick={() => setIsOpenDropdown(!isOpenDropdown)}>
        Move Ticket &nbsp;<i className="fa fa-caret-down" aria-hidden="true"></i>
      </Button>
      {isOpenDropdown && (
        <DropdownMenuContainer ref={dropdownRef}>
          {departments.map((department) => {
            return (
              <DropdownItem key={department.value} onClick={() => onDepartmentChange(department)}>
                {department.value === ticket.department && <i className="fa fa-check" aria-hidden="true"></i>}
                {` ${department.label}`}
              </DropdownItem>
            );
          })}
        </DropdownMenuContainer>
      )}
    </DropdownContainer>
  );
};

export const DownloadReportDropdown = ({ isFreecode, anonymiseReport, downloadReport }) => {
  const dropdownRef = useRef(null);
  const [isOpenDropdown, setIsOpenDropdown] = useDetectOutsideClick(dropdownRef, false);
  const [anonymizeReport, setAnonymizeReport] = useState(false);
  const [showDescription, setShowDescription] = useState(false);

  return (
    <DropdownContainer>
      <Button small primaryBlue primaryGreenBorder margin="5px" onClick={() => setIsOpenDropdown(!isOpenDropdown)}>
        Download Report &nbsp;<i className="fa fa-caret-down" aria-hidden="true"></i>
      </Button>
      {isOpenDropdown && (
        <DropdownMenuContainer ref={dropdownRef}>
          <DropdownItem
            onClick={() => {
              setIsOpenDropdown(false);
              downloadReport('complete', anonymizeReport, showDescription);
            }}
          >
            Complete Report
          </DropdownItem>
          {!isFreecode && (
            <DropdownItem
              onClick={() => {
                setIsOpenDropdown(false);
                downloadReport('candidate', anonymizeReport, showDescription);
              }}
            >
              Candidate Report
            </DropdownItem>
          )}
          <Divider />
          {!anonymiseReport && (
            <LabelAndCheckboxContainer>
              <InputCheckbox
                type="checkbox"
                checked={anonymizeReport}
                onChange={() => setAnonymizeReport(!anonymizeReport)}
              />
              <Label>Anonymise Report</Label>
            </LabelAndCheckboxContainer>
          )}
          <LabelAndCheckboxContainer>
            <InputCheckbox
              type="checkbox"
              checked={showDescription}
              onChange={() => setShowDescription(!showDescription)}
            />
            <Label>Show Description</Label>
          </LabelAndCheckboxContainer>
        </DropdownMenuContainer>
      )}
    </DropdownContainer>
  );
};
